<template>
  <section v-if="variant === variants.v1"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
  >
    <div class="tw-relative tw-flex tw-w-full tw-flex-col tw-items-center tw-text-black lg:tw-max-w-none">
      <h2>{{ vars.titleText }}</h2>
      <LibraryPopupsVideoPopup :videoUrl="currentVideoUrl" v-model:is-visible="isVisible" />
      <div
        v-html="vars.titleHtml"
        class="tw-mb-10 tw-mr-auto tw-flex tw-flex-wrap tw-items-start tw-justify-start tw-gap-x-3 tw-text-start"
      ></div>
      <Swiper
        :modules="[SwiperPagination]"
        @slideChange="onSlideChange"
        :pagination="false"
        :loop="true"
        :space-between="7"
        effect="fade"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 2,
          },
        }"
        @swiper="onSwiper"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(review, index) in reviews"
          :key="`singletestimonials-review-${index}`"
          class="!tw-h-auto tw-px-2"
        >
          <div
            class="tw-flex tw-h-full tw-w-full tw-flex-col tw-bg-white tw-p-4 tw-duration-300 hover:tw-scale-[0.99] hover:tw-shadow-md"
            style="border-radius: var(--rounded)"
          >
            <div class="lg:tw-row tw-flex tw-h-full tw-flex-col tw-items-center tw-gap-5 tw-text-start">
              <LibraryImage
                v-if="review.photo && !review.video"
                :src="review.photo"
                :alt="vars.titleText"
                image-class="tw-w-full"
                :h-ratio="4.5"
                :w-ratio="7"
                style="border-radius: var(--rounded-sm)"
              />
              <div
                v-if="review.photo && review.video"
                class="tw-relative tw-w-full"
                @click="(isVisible = true), (currentVideoUrl = review.video)"
              >
                <LibraryImage
                  :src="review.photo"
                  :alt="vars.titleText"
                  image-class="tw-w-full tw-cursor-pointer"
                  :h-ratio="4.5"
                  :w-ratio="7"
                  style="border-radius: var(--rounded-sm)"
                />
                <button class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2">
                  <svg width="80" height="80" viewBox="0 0 162 162" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="81" cy="81" r="81" fill="white" />
                    <polygon points="65,45 115,81 65,117" fill="black" />
                  </svg>
                </button>
              </div>
              <div class="tw-flex tw-h-full tw-flex-col tw-gap-4 lg:tw-h-auto">
                <div class="tw-flex tw-flex-col tw-gap-1">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg
                      v-for="n in review.rating"
                      :key="`singletestimonials-star-${n}`"
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                        fill="var(--c-secondary)"
                      />
                    </svg>
                  </div>
                  <h4 class="tw-mt-2">{{ review.title }}</h4>
                </div>
                <div
                  class="tw-flex tw-max-h-60 tw-flex-col tw-gap-2 tw-overflow-y-auto xl:tw-max-h-80"
                  v-html="review.description"
                ></div>
                <p class="tw-mt-auto !tw-font-bold">{{ review.author }}</p>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <div>
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v3"
          :can-paginate-back="canPaginateBack"
          :can-paginate-next="canPaginateNext"
        />
      </div>
    </div>
  </section>

 <section v-else-if="variant === variants.v2"
  class="n-section-primary"
  :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
>
  <div class="tw-relative tw-flex tw-w-full tw-flex-col tw-items-center tw-text-black lg:tw-max-w-none">
    <h2>{{ vars.titleText }}</h2>

   

    <div
      v-html="vars.titleHtml"
      class="tw-mb-16  tw-flex tw-flex-wrap tw-gap-x-3 !tw-text-center"
    ></div>

    <Swiper
      :modules="[SwiperPagination]"
      @slideChange="onSlideChange"
      :pagination="false"
      :loop="true"
      :space-between="7"
      effect="fade"
      :clickable="true"
      :breakpoints="{
        320: { slidesPerView: 1 },
        1024: { slidesPerView: 2 }
      }"
      @swiper="onSwiper"
      class="tw-w-full"
    >
      <SwiperSlide
        v-for="(review, index) in reviews"
        :key="`singletestimonials-review-${index}`"
        class="!tw-h-auto tw-px-2"
      >
        <div
          class="tw-flex tw-h-full tw-w-full tw-flex-col tw-bg-white tw-p-4 tw-duration-300 hover:tw-scale-[0.99] hover:tw-shadow-md"
          style="border-radius: var(--rounded)"
        >
          <div class="lg:tw-row tw-flex tw-h-full tw-flex-col tw-items-center  tw-text-start">
           
            <LibraryImage
              v-if="review.photo && !review.video"
              :src="review.photo"
              :alt="vars.titleText"
              image-class="tw-w-full"
              :h-ratio="4.5"
              :w-ratio="7"
              style="border-radius: var(--rounded-sm)"
            />

            
            <div v-else-if="review.video" class="tw-w-full" style="border-radius: var(--rounded-sm); overflow: hidden;">
             
              <library-iframe
                :src="review.video"
                :h-ratio="4.5"
                :w-ratio="7"
                class="tw-w-full"
              />
             
            </div>

            <div class="tw-flex tw-h-full tw-flex-col tw-gap-4 lg:tw-h-auto">
              <div class="tw-flex tw-flex-col tw-gap-1">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg
                    v-for="n in review.rating"
                    :key="`singletestimonials-star-${n}`"
                    width="24"
                    height="24"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                      fill="var(--c-primary)"
                    />
                  </svg>
                </div>
                <h4 class="tw-mt-5">{{ review.title }}</h4>
              </div>

              <div
                class="tw-flex tw-max-h-60 tw-flex-col tw-gap-2 tw-overflow-y-auto xl:tw-max-h-80"
                v-html="review.description"
              ></div>

              <h5 class="tw-mt-5 !tw-font-bold">{{ review.author }}</h5>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>

    <div>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v13"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
  </div>
</section>

<section v-else-if="variant === variants.v3"
  class="n-section-primary"
  :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
>
  <div class="tw-relative tw-flex tw-w-full tw-flex-col tw-items-center lg:tw-max-w-none">
    <h2 class="tw-text-center">{{ vars.titleText }}</h2>

    <div v-html="vars.titleHtml" class="tw-mb-8 tw-flex tw-flex-wrap tw-justify-center tw-gap-x-3 tw-text-center"></div>

    <Swiper
      :modules="[SwiperPagination]"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      :loop="true"
      effect="fade"
      :space-between="16"
      :slides-per-view="1"
      :pagination="paginationOptions"
      class="tw-w-full"
    >
   <SwiperSlide
  v-for="(review, index) in reviews"
  :key="`singletestimonials-review-${index}`"
  class="!tw-h-auto tw-px-2"
>
  <!-- CARD -->
  <div
    class="tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-6 tw-rounded-2xl tw-bg-[#424242] tw-p-6 tw-text-white tw-duration-300 hover:tw-scale-[0.995] hover:tw-shadow-md"
  >
    <div class="tw-grid tw-w-full tw-grid-cols-1 tw-gap-6 lg:tw-grid-cols-12">
      
      <!-- MEDIA (Mobilde üstte, Masaüstünde sağda) -->
      <div class="tw-order-1 lg:tw-order-2 lg:tw-col-span-5">
        <LibraryImage
          v-if="review.photo && !review.video"
          :src="review.photo"
          :alt="vars.titleText"
          image-class="tw-w-full tw-h-full tw-object-cover"
          :h-ratio="4.5"
          :w-ratio="7"
          class="tw-block"
          style="border-radius: var(--rounded-sm)"
        />
        <div
          v-else-if="review.video"
          class="tw-w-full tw-overflow-hidden"
          style="border-radius: var(--rounded-sm);"
        >
          <library-iframe
            :src="review.video"
            :h-ratio="4.5"
            :w-ratio="7"
            class="tw-w-full"
          />
        </div>
      </div>
      
      <!-- TEXT (Mobilde altta, Masaüstünde solda) -->
      <div class="tw-order-2 lg:tw-order-1 lg:tw-col-span-7 tw-flex tw-flex-col">
        <div class="tw-flex tw-items-center tw-gap-2">
          <svg
            v-for="n in review.rating"
            :key="`singletestimonials-star-${n}`"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
              fill="var(--c-primary)"
            />
          </svg>
        </div>
        <h4 class="tw-mt-4">{{ review.title }}</h4>
        <div
          class="tw-mt-3 tw-flex tw-max-h-60 tw-flex-col tw-gap-2 tw-overflow-y-auto xl:tw-max-h-80"
          v-html="review.description"
        ></div>
        <h5 class="tw-mt-5 !tw-font-bold">{{ review.author }}</h5>
      </div>
    </div>
  </div>
  <!-- /CARD -->
</SwiperSlide>

    </Swiper>

    <!-- CUSTOM BULLETS -->
    <div class="testimonials-pagination tw-mt-6 tw-gap-4 tw-cursor-pointer tw-flex tw-items-center tw-justify-center"></div>
  </div>
</section>

</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'VideoTestimonials',
  mixins: [ComponentMixin],

  data() {
    return {
      // v1 & v2 İÇİN VAR OLAN STATE’LERE DOKUNMADAN BIRAKIYORUZ
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,

      // mevcut diğer state'ler
      currentVideoUrl: '',
      isVisible: false,

      // varyantlar
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },

      // SADECE v3'te kullanılacak özel pagination seçenekleri
      paginationOptions: {
        el: '.testimonials-pagination',
        clickable: true,
        renderBullet: (_index: number, className: string) => {
          
          return `
            <span class="${className} custom-bullet" aria-hidden="true">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="12" fill="currentColor"/>
                <rect x="8.16016" y="7.91992" width="7.92" height="7.92" rx="3.96" fill="white"/>
              </svg>
            </span>
          `;
        },
      },
    };
  },

  computed: {
    reviews() {
      return this.groupedVariables.reviews;
    },
  },

  methods: {
    onSwiper(swiper: any) {
      this.swiper = swiper;
    },

    onSlideChange() {
      // v1 & v2’de kullanılan buton aktiflik kontrolü — DAVRANIŞA DOKUNMUYORUZ
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      this.canPaginateBack = !isAtStart;
      this.canPaginateNext = !isAtEnd;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>


<style scoped>
/* Scrollbar (review description kısmı için) */
::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: var(--c-secondary);
}
::-webkit-scrollbar-thumb:window-inactive {
  display: none;
}

/* V3 özel pagination bullet */
.custom-bullet{
  display:inline-flex;align-items:center;justify-content:center;
  width:24px;height:24px;margin:0 6px;
}

/* Swiper varsayılan bullet arka planını ve tap/outline'ı kapat */
:deep(.testimonials-pagination .swiper-pagination-bullet){
  opacity:1;
  background: transparent !important;
  width:auto;height:auto;border:none;box-shadow:none;
  outline:none; -webkit-tap-highlight-color: transparent;
}

/* SVG rengi: pasif gri, aktif primary */
:deep(.testimonials-pagination .swiper-pagination-bullet svg){
  color:#424242; transition: color 200ms ease;
}
:deep(.testimonials-pagination .swiper-pagination-bullet:hover svg){
  color:#5a5a5a;
}
:deep(.testimonials-pagination .swiper-pagination-bullet-active svg){
  color: var(--c-primary);
}

</style>
